import React from 'react'
import { useTranslation } from 'react-i18next'
import { FiPlusCircle } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

interface BundleCourse {
    course_branch_id: number
    course_name: string
    course_images?: string[]
    price?: number
}

interface BundleCardProps {
    course: BundleCourse
    onAddToCart?: (courseId: number) => void
}

const BundleCard: React.FC<BundleCardProps> = ({ course, onAddToCart }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleAddToCart = () => {
        if (onAddToCart) {
            onAddToCart(course.course_branch_id)
        }
    }

    const handleNavigateToCourse = () => {
        navigate(`/course/${course.course_branch_id}?from=bundle`)
    }

    return (
         <div className="bg-white rounded-lg shadow-md overflow-hidden relative flex-shrink-0 w-32 sm:w-48">
            <div className="absolute top-2 left-2 z-8">
                <div className="bg-orange-500 text-white px-1.5 py-0.5 text-xs font-semibold rounded">
                    {t('promotion.bundle_promo')}
                </div>
            </div>

            <div className="aspect-square p-2 cursor-pointer" onClick={handleNavigateToCourse}>
                <img 
                    src={course.course_images && course.course_images.length > 0 ? course.course_images[0] : "/assets/img/products/product1.png"} 
                    alt={course.course_name} 
                    className="w-full h-full object-cover rounded-lg"
                />
            </div>
            <div className="p-2 pt-0">
                <h3 className="font-medium text-sm mb-2 truncate cursor-pointer hover:text-blue-600" onClick={handleNavigateToCourse} >
                    {course.course_name}
                </h3>
                <button 
                    onClick={handleAddToCart}
                    className="w-full bg-theme hover:bg-gray-500 text-white py-1.5 px-2 rounded-full flex items-center justify-center gap-1 text-xs font-medium transition-colors"
                >
                    <FiPlusCircle size={14} />
                    {t('course_view.add_to_cart')}
                </button>
            </div>
        </div>
    )
}

export default BundleCard